module.exports = __webpack_public_path__ + "img/csv.7503fa20.png";